export const nightgalePageConfig = {
  title: 'Return',
  titleCN: '回流',
  subTitle: '',
  subTitleCN: '',
  path: '/engagement/return',
  defaultTab: 'return',
  tabList: [
    {
      id: 'return',
      tabName: 'Return',
      tabNameCN: '回流',
      isHaveNotification: true,
      notificationPath: '/engagement/return',
      path: '/engagement/return',
      tabIcon: '',
      logConfig: {
        pageId: '201001',
        pageName: 'engaementReturn',
        extInfo: 'engaementReturn',
        pagePath: '/engagement/return',
      },
      filters: [
        {
          name: 'ReturnFilter',
          isOpenSticky: true,
          isHaveFilterSave: true,
          filterPath: '/engagement/return',
          componentList: [
            {
              name: 'ReturnTrendCo',
              className: 'margin-t-20',
              style: {},
              type: 'view',
              props: {
                config: {
                  api: '/api/v1/dashboard/pc/engagement/return/trend',
                  enTitle: 'Daily Return Users',
                  cnTitle: '每日回流用户',
                  enWeekTitle: 'Weekly/Biweekly Return Users',
                  cnWeekTitle: '周/双周回流用户',
                  enMonthTitle: 'Monthly Return Users',
                  cnMonthTitle: '月回流用户',
                  componentMetrics: [{
                    enName: "Today",
                    cnName: "当日",
                    enWeekName: "Weekly Return Users",
                    cnWeekName: "周回流用户",
                    enMonthName: "This Month",
                    cnMonthName: "本月回流",
                    metricKey: "this_value",
                    type: "int",
                    decimal: 0
                  }, {
                    enName: "Same Day Last Week",
                    cnName: "上周同期",
                    enWeekName: "Biweekly Return Users",
                    cnWeekName: "双周回流用户",
                    enMonthName: "Last Year",
                    cnMonthName: "去年同期回流",
                    metricKey: "pre_cycle_value",
                    type: "int",
                    decimal: 0,
                  }],
                }
              },
            },
            {
              name: "OverallTableCo",
              className: "margin-t-20",
              type: "view",
              style: { marginBottom: '-10px' },
              props: {
                config: {
                  isHaveDiff: false,
                  useTime: true,
                  showStatistic: ["sum", "avg"],
                  slotConfig: {
                    isShowValueType: false,
                    isShowMetricsSettings: false,
                    isShowProgressBar: false,
                    isShowdownloadConfig: false,
                  },
                  valueTypeConfig: {
                    valueType: "dod",
                  },
                  api: {
                    tableApi: "/api/v1/dashboard/pc/engagement/return/detail_table",
                    tableDownloadApi: "/api/v1/dashboard/pc/engagement/return/detail_down",
                  },
                  titleConfig: {
                    Day: {
                      titleEn: "Daily Return Users Details",
                      titleCn: "每日回流用户表",
                    },
                    Week: {
                      titleEn: "Weekly/Biweekly Return Users Details",
                      titleCn: "周/双周回流用户表",
                    },
                    Month: {
                      titleEn: "Monthly Return Users Details",
                      titleCn: "月回流用户表",
                    }
                  },
                  componentMetricsConfig: {
                    Day: [
                      {
                        metricKey: "return_users",
                        reqMetricKey: "return_users",
                        enPercentWidth: 200,
                        cnPercentWidth: 200,
                        enWidth: 200,
                        cnWidth: 200,
                        enName: "Daily Return Users",
                        cnName: "日回流用户",
                        rainbowKey: "Daily Return Users",
                        type: "int",
                        decimal: 0,
                        percentDecimals: 1
                      }
                    ],
                    Week: [
                      {
                        metricKey: "return_users",
                        reqMetricKey: "return_users",
                        enPercentWidth: 200,
                        cnPercentWidth: 200,
                        enWidth: 200,
                        cnWidth: 200,
                        enName: "Weekly Return Users",
                        cnName: "周回流用户",
                        rainbowKey: "Weekly Return Users",
                        type: "int",
                        decimal: 0,
                        percentDecimals: 1
                      },
                      {
                        metricKey: "bi_return_users",
                        reqMetricKey: "bi_return_users",
                        enPercentWidth: 200,
                        cnPercentWidth: 200,
                        enWidth: 200,
                        cnWidth: 200,
                        enName: "Biweekly Return Users",
                        cnName: "双周回流用户",
                        rainbowKey: "Biweekly Return Users",
                        type: "int",
                        decimal: 0,
                        percentDecimals: 1
                      }
                    ],
                    Month: [
                      {
                        metricKey: "return_users",
                        reqMetricKey: "return_users",
                        enPercentWidth: 200,
                        cnPercentWidth: 200,
                        enWidth: 200,
                        cnWidth: 200,
                        enName: "Monthly Return Users",
                        cnName: "月回流用户",
                        rainbowKey: "Monthly Return Users",
                        type: "int",
                        decimal: 0,
                        percentDecimals: 1
                      }
                    ]
                  }
                }
              }
            },
            {
              name: "CommonRow",
              className: 'margin-t-10',
              type: "layout",
              style: {},
              props: {},
              children: [
                {
                  name: "RankListTabCo",
                  className: '',
                  style: {},
                  type: "view",
                  data: {
                    regionDataType: "country",
                    tabOrder: ["country", "os", "region"],
                  },
                  children: [
                    {
                      name: "CommonRankListCo",
                      className: '',
                      type: "view",
                      style: {},
                      props: {
                        config: {
                          api: "/api/v1/dashboard/pc/engagement/return/top",
                          metric: "return",
                          haveCalBubble: false,
                          isUserQuota: true,
                          chartDataKey: 'return_date_list',
                          tableDataKey: 'return_list',
                          componentMetrics: {
                            reqMetricKey: "return",
                            metricKey: "value",
                            enTitleName: "Return",
                            cnTitleName: "回流用户",
                            enName: "Return",
                            cnName: "回流",
                            enWeekName: "Return",
                            cnWeekName: "回流",
                            enMonthName: "Return",
                            cnMonthName: "回流",
                            rangeEnName: "Sum Return",
                            rangeCnName: "回流总数",
                            rangeEnWeekName: "Sum Return",
                            rangeCnWeekName: "回流总数",
                            rangeEnMonthName: "Sum Return",
                            rangeCnMonthName: "回流总数",
                            prefix: "Sum",
                            type: "int",
                            decimal: 0,
                            percentDecimals: 1,
                          },
                          comConfig: {
                            isHaveBar: true,
                            isHaveLine: true,
                            isHavePie: true,
                            isHaveShare: true
                          },
                          showConfig: {
                            showTable: true,
                            showChart: true,
                          }
                        }
                      }
                    },
                  ]
                },
              ],
            },
          ]
        },
      ],
    },
  ]
}

